import { IUserContext } from '@truckdown/systems';

export { PromotionType } from './PromotionType';
export { PromotionBillingPeriod } from './PromotionBillingPeriod';
export { PromotionStatus } from './PromotionStatus';

export type { AddPromotionModel } from './AddPromotionModel';
export type { AddFundsModel } from './AddFundsModel';
export type { EditPromotionModel } from './EditPromotionModel';
export type { PromotionModelBase } from './PromotionModelBase';
export type { PromotionDisplayModel } from './PromotionDisplayModel';
export type { PromotionFundsModel } from './PromotionFundsModel';
export type { PromotionRecurringChargeModel } from './PromotionRecurringChargeModel';
export type { PromotionModel } from './PromotionModel';
export type { PromotionQueryModel } from './PromotionQueryModel';
export type { PromotionSearchModel } from './PromotionSearchModel';
export type { SetRecurringChargeModel } from './SetRecurringChargeModel';
export type { UpdateExpiryModel } from './UpdateExpiryModel';

import { IPromotionManager } from './IPromotionManager';
import { IPromotionQueryService } from './IPromotionQueryService';
import { IPromotionSearchService } from './IPromotionSearchService';
export type { IPromotionManager };
export type { IPromotionQueryService };
export type { IPromotionSearchService };

export default function (context: IUserContext): void {
    context.registerService({
        name: 'IPromotionManager',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "PromotionManager" */ './PromotionManager');
            return new svc.PromotionManager(context) as IPromotionManager;
        }
    });

    context.registerService({
        name: 'IPromotionQueryService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "PromotionQueryService" */ './PromotionQueryService');
            return new svc.PromotionQueryService(context) as IPromotionQueryService;
        }
    });

    context.registerService({
        name: 'IPromotionSearchService',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "PromotionSearchService" */ './PromotionSearchService');
            return new svc.PromotionSearchService(context) as IPromotionSearchService;
        }
    });
}